// Autogenerated by namespace Frontend.Sports.ContractsBuilder

import { Injectable } from '@angular/core';
import { ClientConfig, ClientConfigProductName, ClientConfigService, LazyClientConfig, LazyClientConfigBase, LazyClientConfigService } from '@frontend/vanilla/core';
import { AccaBoostCalculations } from '@frontend/sports/types/components/acca-boost';
import { ProfileActionsSwitch, ProfileConfiguration } from '@frontend/sports/types/components/a-r-c';
import { AZSportsViewModel } from '@frontend/sports/types/components/a-z-menu';
import { GamesBannersConfig, JackpotBannersConfig, VirtualsBannersConfig } from '@frontend/sports/types/components/banners';
import { BetBuilderAmbassador, IframeUrlParams, ScorecastLongIdPrefixes } from '@frontend/sports/types/components/bet-builder';
import { FixtureLimitByMarketType } from '@frontend/sports/types/components/bet-finder';
import { BetslipDisplayMode } from '@frontend/sports/types/components/bet-placement';
import { SportSpecificPitchStyling } from '@frontend/sports/types/components/betradar-visualization';
import { OptionNameMappingConfiguration, OptionNameOverridesViewModel, TranslationsModel } from '@frontend/sports/types/components/bet-recommender';
import { AlternateLinesCompetitionConfig } from '@frontend/sports/types/components/betslip-config';
import { BetslipOddsPreferencesReminderConfiguration } from '@frontend/sports/types/components/betslip-odds-preferences-reminder';
import { BetslipUpsellMarketsGroup } from '@frontend/sports/types/components/betslip-upsell';
import { CalendarModel } from '@frontend/sports/types/components/calendar';
import { LinkTemplateForClient } from '@frontend/sports/types/components/client-content';
import { AutomatedMarqueeTile, AutomatedMarqueeTileImage, BetBuilderCustomMessage, BetBuilderThemedTab, MarqueeTile } from '@frontend/sports/types/components/content';
import { CrmTokenConfig } from '@frontend/sports/types/components/crm-offers';
import { AwardTypeParameters, CrmPostBetSignpostingConfiguration } from '@frontend/sports/types/components/crm-post-bet-signposting';
import { CrmPromotionConfiguration } from '@frontend/sports/types/components/crm-promotions';
import { IconInfo } from '@frontend/sports/types/components/event-details';
import { EventDetailsSitemapDictionary } from '@frontend/sports/types/components/event-details/types';
import { DisabledNotificationSport, GreyhoundsRacingEasyBetViewOption, HorseRacingEasyBetViewOption, LiveIndicatorType } from '@frontend/sports/types/components/features';
import { CoordinatorSettings, InstallerSettings } from '@frontend/sports/types/components/geolocation';
import { MapMarketToGameTemplateIds, MarqueeGroupsOfMarkets, MarqueeVariantVersions, SixPackGridGroupMapping } from '@frontend/sports/types/components/highlights-marquee';
import { ImageCompressionFormat, SportCompetitionFormat } from '@frontend/sports/types/components/images';
import { HeadlineModel } from '@frontend/sports/types/components/intro-pages';
import { MarketingViewModel } from '@frontend/sports/types/components/marketing';
import { MatchSimulationConfiguration, PerformMappingsConfiguration } from '@frontend/sports/types/components/media';
import { MarketGridGroup } from '@frontend/sports/types/components/multi-builder';
import { IExportButtonType } from '@frontend/sports/types/components/my-bets';
import { SportConfiguration } from '@frontend/sports/types/components/native-alert';
import { NextToGoGroupsOfMarkets, NextToGoModule } from '@frontend/sports/types/components/next-to-go';
import { OddsDisplayConfiguration } from '@frontend/sports/types/components/odds-display';
import { ParticipantImageFormat } from '@frontend/sports/types/components/outrights-grid';
import { PopularBetsPodTypes } from '@frontend/sports/types/components/popular-bets';
import { UrlTranslation } from '@frontend/sports/types/components/pretty-urls';
import { QuickLinkViewModel } from '@frontend/sports/types/components/quick-links';
import { MarketMappingConfiguration, RandomMultiGeneratorSportsConfig, RandomMultiGeneratorSportsSelection } from '@frontend/sports/types/components/random-multi-generator';
import { BackgroundImage, ShowcaseGroupsOfMarkets, ShowcaseViewModel } from '@frontend/sports/types/components/showcase';
import { BetBuilder, BetBuilderEntainUI, BetBuilderHelpPage, BetBuilderSignposting, BetFinder, Betslip, BetslipSettings, BetslipUpsell, BetStation, BettingPreferences, CashoutSettings, ContentMessages, Coupons, CouponTags, CrmPostBetSignposting, CrmPromotions, CrmPromotionsBanners, CrmTokens, EarlyPayout, EarlyPayoutErrors, EarlyPayoutSettings, EarlyPayoutV2, ESportsConfig, Event, EventGameNotes, EventGrid, EventGridMarketHeaders, EventScoreboard, FavouritesDashboard, FavouritesMessages, Fixture, FormCoupon, FreeBetOverview, GeoLocation, GlobalMessages, GreyHoundRacing, HorseRacing, LinkExternalAccounts, LiveAnimation, LiveNavigation, LiveSportsVisualizationTranslation, Lobby, MarketHelp, MarketSubtypeLogo, Marquee, Media, Media_NotLoggedin, Menus, ModalDialogs, MultiBuilder, MultiRandomGenerator, MyBets, MyBetsFilterView, MyBetsPrint, NativeAlert, NgrxReports, OddsDisplay, PanicButtonMessages, PlayerStatisticsMessages, PopularBetsMessagesConfig, PopularPicks, QuickBet, QuickBetButtonStates, QuickBetHelp, QuickBetMessages, QuickBetModalDialog, QuickBetNumpad, ReBet, ReturnsMessage, SeasonStatisticsMessages, Seo, ShareMyBet, ShowcaseMessages, SitecoreAccaBoost, SitecoreStatistics, StakeChanges, SystemBets, TeamGrouping, ToastLiveNotifications, ToastNotifications, Widgets } from '@frontend/sports/types/components/sitecore';
import { SportOfferOrder, VirtualSportsConfiguration } from '@frontend/sports/types/components/sports';
import { AllSportsSection, PopularSection, RecentlyVisitedSection } from '@frontend/sports/types/components/sports-product-menu';
import { CompetitionRecordsFormat, DirectMatchesBarColors, PromotionHighlightColorsWithPositions } from '@frontend/sports/types/components/statistics';
import { TeamPagesViewModel } from '@frontend/sports/types/components/team-pages';
import { TeaserBetPointsSlider, TeaserBetTemplateIds, TeaserPriceTableCacheDuration } from '@frontend/sports/types/components/teaser-bet';
import { Tournament } from '@frontend/sports/types/components/tournaments';
import { PageRefreshConfig, Widget } from '@frontend/sports/types/components/widget';
import { LinkListLayout } from '@frontend/sports/types/components/widget/types';
import { CultureUrl } from '@frontend/sports/types/components/world-cup-event-hub';
import { EventCarouselVisibilityConfig, MarketGroupsWithNewBadge, MarketSwitcherPositionType, OptionGroupRowsThreshold, OptionPanelThreshold, OptionTypesToFilterTV2MarketOptions, OverrideParticipantNameOptionMarkets, PrimaryNavigationDisplayType, ScorecastRegexValues, VerticalGridGroupOption } from '@frontend/sports/types/configuration';
import { BogVersion, EventDetailsModel, PlayerStatisticsInfo, RegionTrapImage, SecondaryBroadcastInfo, TokenCardDetailsMessages, TokenCardDetailsReplaceParameters, TrapImage } from '@frontend/sports/types/configuration/client-configuration';
import { BetradarImage } from '@frontend/sports/types/models/bet-radar';
import { ConfigSettings } from '@frontend/sports/types/models/config-settings';
import { CRMTokenImage } from '@frontend/sports/types/models/crm-tokens';
import { CdnaUserProfile } from '@frontend/sports/types/models/customer-dna';
import { EarlyPayoutPushErrorItem } from '@frontend/sports/types/models/early-payout';
import { MyBetsBetslipImage, MyBetsGridScoreBoardConfigResponse, OneLinkConfig } from '@frontend/sports/types/models/my-bets';
import { NavigationBarItem, NavigationSportsConfig } from '@frontend/sports/types/models/navigation-bar';
import { PopularBetsFallbackLogoModel } from '@frontend/sports/types/models/popular-bets';
import { PopularSearchModel } from '@frontend/sports/types/models/popular-search';
import { ScoreboardBackground, ScoreboardBackgroundModel } from '@frontend/sports/types/models/scoreboard';
import { OddsDisplayFormat, UserSettingsData } from '@frontend/sports/types/models/user-settings';
import { ClientViewTemplate } from '@frontend/vanilla/types/content/client/documents';

@ClientConfig({ key:'msAccaBoost' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: accaBoostConfigFactory,
})
export class AccaBoostConfig {
	accaBoostCalculation: AccaBoostCalculations;
	accaBoostInfoVersion: string;
	allowUnAuthenticatedUsers: boolean;
	areNotificationsEnabled: boolean;
	errorNotificationDuration: number;
	hideCategoriesInTokenDrawer: boolean;
	icon: string;
	isCompactLadderEnabled: boolean;
	isEnabled: boolean;
	isEnhancedLayoutEnabled: boolean;
	maxRewardNotificationDuration: number;
	notificationDuration: number;
	oneSelectionAwayNotificationDuration: number;
	pollingInterval: number;
	sitecoreTokenDataCacheTime: number;
}

export function accaBoostConfigFactory(service: ClientConfigService): AccaBoostConfig {
	return service.get(AccaBoostConfig);
}

@ClientConfig({ key:'msAccountBalance' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: accountBalanceConfigFactory,
})
export class AccountBalanceConfig {
	retry: number;
	retryDelay: number;
	timeout: number;
}

export function accountBalanceConfigFactory(service: ClientConfigService): AccountBalanceConfig {
	return service.get(AccountBalanceConfig);
}

@LazyClientConfig({ key:'msAnimationBackgrounds' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: animationBackgroundsFactory,
})
export class AnimationBackgrounds extends LazyClientConfigBase {
	backgrounds: ScoreboardBackground[];
}

export function animationBackgroundsFactory(service: LazyClientConfigService): AnimationBackgrounds {
	return service.get(AnimationBackgrounds);
}

@ClientConfig({ key:'msAnimation' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: animationConfigFactory,
})
export class AnimationConfig {
	isBasketballAnimationEnabled: boolean;
	isIceHockeyAnimationEnabled: boolean;
	isTennisAnimationEnabled: boolean;
}

export function animationConfigFactory(service: ClientConfigService): AnimationConfig {
	return service.get(AnimationConfig);
}

@ClientConfig({ key:'msApp' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: appConfigFactory,
})
export class AppConfig {
	appName: string;
	lcpFallbackTimeout: number;
	modalDialogGesturesEnabled: boolean;
	offlineDurationReloadThreshold: number;
	pageHiddenReloadThreshold: number;
	publicAccessId?: string;
	setAccountIdCookie: boolean;
}

export function appConfigFactory(service: ClientConfigService): AppConfig {
	return service.get(AppConfig);
}

@ClientConfig({ key:'msARC' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: aRCConfigFactory,
})
export class ARCConfig {
	isPlayBreakEnabled: boolean;
	isUserProfilingEnabled: boolean;
	pageHiddenReloadThreshold: number;
	profileActionsSwitch: ProfileActionsSwitch;
	showSelfExclusionLock: boolean;
}

export function aRCConfigFactory(service: ClientConfigService): ARCConfig {
	return service.get(ARCConfig);
}

@ClientConfig({ key:'msArcUser' , product: ClientConfigProductName.SPORTS, reload: true })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: arcUserConfigFactory,
})
export class ArcUserConfig {
	arcPlayBreak: boolean;
	arcProfileDetails: ProfileConfiguration;
}

export function arcUserConfigFactory(service: ClientConfigService): ArcUserConfig {
	return service.get(ArcUserConfig);
}

@ClientConfig({ key:'msAutomatedMarqueeTiles' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: automatedMarqueeTilesConfigFactory,
})
export class AutomatedMarqueeTilesConfig {
	automatedMarqueesTileImages: AutomatedMarqueeTileImage[];
	automatedMarqueesTiles: AutomatedMarqueeTile[];
}

export function automatedMarqueeTilesConfigFactory(service: ClientConfigService): AutomatedMarqueeTilesConfig {
	return service.get(AutomatedMarqueeTilesConfig);
}

@ClientConfig({ key:'msAZMenu' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: aZMenuConfigFactory,
})
export class AZMenuConfig {
	allowedEsportsOnAZMenu: number[];
	removeLetterBreakersInMobile: boolean;
	showAZCustomLinks: boolean;
	showNewBadge: boolean;
}

export function aZMenuConfigFactory(service: ClientConfigService): AZMenuConfig {
	return service.get(AZMenuConfig);
}

@ClientConfig({ key:'msAZSportsData' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: aZSportsDataModelFactory,
})
export class AZSportsDataModel {
	azSports: AZSportsViewModel[];
}

export function aZSportsDataModelFactory(service: ClientConfigService): AZSportsDataModel {
	return service.get(AZSportsDataModel);
}

@ClientConfig({ key:'msBanners' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: bannersConfigFactory,
})
export class BannersConfig {
	appendSessionKey: boolean;
	depositUrl: string;
	desktopCasinoBannerOpenTarget: string;
	enabled: boolean;
	games: GamesBannersConfig;
	isKYCCheckEnabled: boolean;
	jackpot: JackpotBannersConfig;
	keepAliveUrl: string;
	lobbyType: string;
	parentUrl: string;
	responsibleGamingUrl: string;
	showLearnMoreButton: boolean;
	virtuals: VirtualsBannersConfig;
}

export function bannersConfigFactory(service: ClientConfigService): BannersConfig {
	return service.get(BannersConfig);
}

@ClientConfig({ key:'msBaseTranslation' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: baseTranslationConfigFactory,
})
export class BaseTranslationConfig {
	defaultLanguage: string;
	isEnabled: boolean;
}

export function baseTranslationConfigFactory(service: ClientConfigService): BaseTranslationConfig {
	return service.get(BaseTranslationConfig);
}

@ClientConfig({ key:'msBetBuilder' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: betBuilderConfigFactory,
})
export class BetBuilderConfig {
	ambassadors: BetBuilderAmbassador[];
	betFeedbackRetryCount: number;
	betFeedbackRetryDelay: number;
	betGeniusIframeUrlParameters?: Record<string, IframeUrlParams | undefined>;
	betGeniusWidgetLanguage: string;
	customMessages: Record<string, BetBuilderCustomMessage[] | undefined>;
	defaultSGPExpandedMarketsCount: number;
	defaultSGPOverlayExpandedMarketsCount: number;
	editIconButtonOverride: boolean;
	enablePrecreatedBetBuilderTab: boolean;
	hideBetbuilderDrawer: boolean;
	incrementForPrecreatedMarketsShowMore: number;
	initialPrecreatedMarketsPerSport: number;
	isBetBuilderEnabled: boolean;
	isBetBuilderEnabledForSport?: number[];
	isBetBuilderInfoMessageEnabled: boolean;
	isBetBuilderNewBadgeEnabledForSport?: number[];
	isPrecreatedBetBuilderBadgeEnabled: boolean;
	isPrecreatedBetBuilderEnabled: boolean;
	isPrecreatedBetBuilderNewBadgeEnabledForSport?: number[];
	liveBetBuilderEnabledCompetitions?: number[];
	liveBetBuilderEnabledSports?: number[];
	maxSelectionsPerPick: number;
	onboardingMessageEnabledSports?: number[];
	onboardingMessageMaxAppearances: number;
	pageSize: number;
	scorecastLongIdPrefixes?: ScorecastLongIdPrefixes;
	showEntainUiInOverlay: boolean;
	showSGPButtonsInPrebuiltSGP: boolean;
	themedTabs: Record<string, BetBuilderThemedTab[] | undefined>;
	useBetBuilderInEntainUI?: number[];
}

export function betBuilderConfigFactory(service: ClientConfigService): BetBuilderConfig {
	return service.get(BetBuilderConfig);
}

@ClientConfig({ key:'msBetContextualTracking' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: betContextualTrackingConfigFactory,
})
export class BetContextualTrackingConfig {
	allowedPages: string[];
	betContextAPIVersion: string;
	enableExtendedDataTracking: string[];
	isEnabled: boolean;
}

export function betContextualTrackingConfigFactory(service: ClientConfigService): BetContextualTrackingConfig {
	return service.get(BetContextualTrackingConfig);
}

@ClientConfig({ key:'msBetFinder' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: betFinderConfigFactory,
})
export class BetFinderConfig {
	displaySportsFiltersForSuggestions: boolean;
	enableAllFilterTabForSuggestions: boolean;
	fixtureLimitByMarketType: FixtureLimitByMarketType;
	loaderTimeDelay: number;
	maxEventsAmount: number;
	maxNumberOfRecentlySearchItems: number;
	maxRecentSearchCount: number;
	minSearchStringLength: number;
	popupHeaderOverride: boolean;
	recentlySearchedExpirationDays: number;
	showLoader: boolean;
}

export function betFinderConfigFactory(service: ClientConfigService): BetFinderConfig {
	return service.get(BetFinderConfig);
}

@ClientConfig({ key:'msBetradarImages' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: betradarImagesFactory,
})
export class BetradarImages {
	images: BetradarImage[];
}

export function betradarImagesFactory(service: ClientConfigService): BetradarImages {
	return service.get(BetradarImages);
}

@ClientConfig({ key:'msBetradarVisualization' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: betradarVisualizationConfigFactory,
})
export class BetradarVisualizationConfig {
	clientId: string;
	languageMapping: Record<string, string | undefined>;
	pitchConfiguration: Record<string, string | undefined>;
	pitchLogoEnabled: number[];
	scriptUrl: string;
	sideLineLogoEnabled: number[];
	sportSpecificPitchConfiguration: Record<number, SportSpecificPitchStyling | undefined>;
	stickyAddonSupportedSports: number[];
	supportedCoverageLevel: Record<number, number | undefined>;
	supportedSports: number[];
	teamInvertCompetitions: Record<number, number[] | undefined>;
}

export function betradarVisualizationConfigFactory(service: ClientConfigService): BetradarVisualizationConfig {
	return service.get(BetradarVisualizationConfig);
}

@ClientConfig({ key:'msBetRecommender' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: betRecommenderConfigFactory,
})
export class BetRecommenderConfig {
	isEnabled: boolean;
	minimumLoadingDelay: number;
	optionNameMapping: Record<number, OptionNameMappingConfiguration[] | undefined>;
}

export function betRecommenderConfigFactory(service: ClientConfigService): BetRecommenderConfig {
	return service.get(BetRecommenderConfig);
}

@ClientConfig({ key:'msBetRecommenderConfigData' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: betRecommenderConfigDataFactory,
})
export class BetRecommenderConfigData {
	optionNameOverrides: OptionNameOverridesViewModel[];
	translations?: TranslationsModel;
}

export function betRecommenderConfigDataFactory(service: ClientConfigService): BetRecommenderConfigData {
	return service.get(BetRecommenderConfigData);
}

@ClientConfig({ key:'msBetslipBar' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: betslipBarConfigFactory,
})
export class BetslipBarConfig {
	displayMyBets: boolean;
	enableIntegratedSheetView: boolean;
	hideOnEmptyBetslip: boolean;
	includeStakeInWinnings: boolean;
	isAngstromSGPEnabled: boolean;
	isEnabledDsl: string;
	showOnMyBets: boolean;
}

export function betslipBarConfigFactory(service: ClientConfigService): BetslipBarConfig {
	return service.get(BetslipBarConfig);
}

@ClientConfig({ key:'msBetslip' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: betslipConfigFactory,
})
export class BetslipConfig {
	allowBetbuilderCombos: boolean;
	allowClientComboPrevention: boolean;
	allowMixedVirtualsCombo: boolean;
	allowMultipleSingles: boolean;
	alternateLinesConfig: Record<number, AlternateLinesCompetitionConfig | undefined>;
	betslipToasterVisibilityTimespan: number;
	cdsPicksPollingInterval: number;
	depositSuccessfulVisibilityTimespan: number;
	disableOLTracking: boolean;
	displayMode: BetslipDisplayMode;
	enableSwipeToDelete: boolean;
	excludeNonCombinableBets: boolean;
	globalErrorVisibilityTimespan: number;
	hideStraightBetDeclined: boolean;
	isAcceptAndPlaceBetEnabled: boolean;
	isAutoExpandCollapseModulesEnabled: boolean;
	isBalanceHeaderEnabled: boolean;
	isBankerEnabled: boolean;
	isBetBuilderLegSelectionEnabled: boolean;
	isBetRewardPointsEnabled: boolean;
	isCloseCtaTextEnabled: boolean;
	isDepositAndPlaceBetEnabled: boolean;
	isDepositOnBetslipConfirmationEnabled: boolean;
	isDoubleBetPreventionEnabled: boolean;
	isEmptyDefaultStakeEnabled: boolean;
	isLineSwitcherEnabled: boolean;
	isLinearCollapsibleModulesEnabled: boolean;
	isLinearKeypadEnabled: boolean;
	isLinearSeparateBetBuilderModuleEnabled: boolean;
	isLinearToggleSwitcherEnabled: boolean;
	isLiveOneClickDepositEnabled: boolean;
	isMinStakeButtonEnabled: boolean;
	isMultiReturnsMessageEnabled: boolean;
	isRemoveBetBuilderLegButtonEnabled: boolean;
	isRewardCtaEnabled: boolean;
	isSgpBadgeInTitleEnabled: boolean;
	isSportcastAsComboEnabled: boolean;
	isSystemBetEnabled: boolean;
	isSystemMOfNEnabled: boolean;
	isTotalOddsIndicatorEnabled: boolean;
	isUndoForDeletedLegsEnabled: boolean;
	linearBetslipTypesOrder: string[];
	linearModeCheckboxesEnabled: boolean;
	maxBetslipBets: number;
	maxComboBets: number;
	maxSystemBets: number;
	maxTeaserBets: number;
	minComboBets: number;
	minSystemBets: number;
	minTeaserBets: number;
	noWaitingBalanceRefresh: boolean;
	payPalWalletSelectionEnabledForCountries: string[];
	paypalWalletIconClass: Record<string, string | undefined>;
	paypalWalletUseNewFormula: boolean;
	preventDuplicateRequestOnFrontend: boolean;
	removeAllPicksConfirmationTimeout: number;
	roundPriceValues: boolean;
	roundValues: boolean;
	selectionsGeneralStakeEnabled: boolean;
	showAccountBalanceWithSportsBonus: boolean;
	showBalanceAndDepositOnBetslip: boolean;
	showBalanceOnQuickBet: boolean;
	showLoginButtonInHeader: boolean;
	sportsToHideRegionInfo: number[];
	systemBetsNameType: string;
	taxCalculation: string;
	trackingMeasurementProtocolEnabled: boolean;
	validation?: Record<string, string | undefined>;
}

export function betslipConfigFactory(service: ClientConfigService): BetslipConfig {
	return service.get(BetslipConfig);
}

@LazyClientConfig({ key:'msBetslipOnboarding' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: betslipOnboardingConfigFactory,
})
export class BetslipOnboardingConfig extends LazyClientConfigBase {
	comboOnboardingImageUrl?: string;
	systemOnboardingImageUrl?: string;
	teaserOnboardingImageUrl?: string;
}

export function betslipOnboardingConfigFactory(service: LazyClientConfigService): BetslipOnboardingConfig {
	return service.get(BetslipOnboardingConfig);
}

@LazyClientConfig({ key:'msBetslipUpsell' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: betslipUpsellConfigFactory,
})
export class BetslipUpsellConfig extends LazyClientConfigBase {
	blackListedCountries: string[];
	isBetslipUpsellExpanded: boolean;
	isEnabledForMulti: boolean;
	isEnabledForSingle: boolean;
	marketGridGroupIds: BetslipUpsellMarketsGroup[];
	maxUpsells: number;
	moduleBackgroundImage?: string;
	modulePosition: string;
	overrideDontShow: boolean;
	timeRangeDifferenceValue: number;
}

export function betslipUpsellConfigFactory(service: LazyClientConfigService): BetslipUpsellConfig {
	return service.get(BetslipUpsellConfig);
}

@LazyClientConfig({ key:'msBetStationEDSTriggers' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: betStationEDSTriggersConfigFactory,
})
export class BetStationEDSTriggersConfig extends LazyClientConfigBase {
	signpostingEnabled: boolean;
}

export function betStationEDSTriggersConfigFactory(service: LazyClientConfigService): BetStationEDSTriggersConfig {
	return service.get(BetStationEDSTriggersConfig);
}

@ClientConfig({ key:'msBetstationTopScreenModular' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: betstationTopScreenModularConfigFactory,
})
export class BetstationTopScreenModularConfig {
	isEnabled: boolean;
}

export function betstationTopScreenModularConfigFactory(service: ClientConfigService): BetstationTopScreenModularConfig {
	return service.get(BetstationTopScreenModularConfig);
}

@ClientConfig({ key:'msBetstationWidget' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: betstationWidgetConfigFactory,
})
export class BetstationWidgetConfig {
	pageRefreshInterval: PageRefreshConfig[];
}

export function betstationWidgetConfigFactory(service: ClientConfigService): BetstationWidgetConfig {
	return service.get(BetstationWidgetConfig);
}

@ClientConfig({ key:'msBettingInsights' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: bettingInsightsConfigurationFactory,
})
export class BettingInsightsConfiguration {
	isEnabled: boolean;
}

export function bettingInsightsConfigurationFactory(service: ClientConfigService): BettingInsightsConfiguration {
	return service.get(BettingInsightsConfiguration);
}

@LazyClientConfig({ key:'msBettingInsightsSitecore' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: bettingInsightsSitecoreConfigFactory,
})
export class BettingInsightsSitecoreConfig extends LazyClientConfigBase {
	moneyBets: string;
	overLabel: string;
	spreadBets: string;
	totalBets: string;
	underLabel: string;
}

export function bettingInsightsSitecoreConfigFactory(service: LazyClientConfigService): BettingInsightsSitecoreConfig {
	return service.get(BettingInsightsSitecoreConfig);
}

@ClientConfig({ key:'msBettingOffer' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: bettingOfferConfigFactory,
})
export class BettingOfferConfig {
	balancedLineSelectionStrategyBySport: Record<number, string | undefined>;
	golfSiblingMapping: Record<string, string | undefined>;
	includeLinkedFixtures: boolean;
	isMainToLiveTransitionEnabled: boolean;
	mainToLiveFixedPushDelay: number;
	mainToLiveMaxRandomPushDelay: number;
	pushBufferingDuration: number;
}

export function bettingOfferConfigFactory(service: ClientConfigService): BettingOfferConfig {
	return service.get(BettingOfferConfig);
}

@LazyClientConfig({ key:'msBookieTicker' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: bookieTickerConfigFactory,
})
export class BookieTickerConfig extends LazyClientConfigBase {
	messageIcons: Record<string, Record<string, IconInfo | undefined> | undefined>;
}

export function bookieTickerConfigFactory(service: LazyClientConfigService): BookieTickerConfig {
	return service.get(BookieTickerConfig);
}

@ClientConfig({ key:'msCalendar' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: calendarConfigFactory,
})
export class CalendarConfig {
	hideEnhancedAccas?: number[];
	showCalendarTab: boolean;
	topMenuDateFormat: string;
}

export function calendarConfigFactory(service: ClientConfigService): CalendarConfig {
	return service.get(CalendarConfig);
}

@ClientConfig({ key:'msCalendarData' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: calendarDataFactory,
})
export class CalendarData {
	calendarItems: CalendarModel;
}

export function calendarDataFactory(service: ClientConfigService): CalendarData {
	return service.get(CalendarData);
}

@ClientConfig({ key:'msCasinoMiniGames' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: casinoMiniGamesConfigFactory,
})
export class CasinoMiniGamesConfig {
	appendSessionKey: boolean;
	areMiniGamesEnabled: boolean;
	blackListedCountries: string[];
	isKYCCheckEnabled: boolean;
	sportsSpinnerLoadingDelayTime: number;
	url?: string;
}

export function casinoMiniGamesConfigFactory(service: ClientConfigService): CasinoMiniGamesConfig {
	return service.get(CasinoMiniGamesConfig);
}

@ClientConfig({ key:'msCDNCaching' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: cDNCachingConfigFactory,
})
export class CDNCachingConfig {
	widgets: string[];
}

export function cDNCachingConfigFactory(service: ClientConfigService): CDNCachingConfig {
	return service.get(CDNCachingConfig);
}

@ClientConfig({ key:'msCds' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: cdsConfigFactory,
})
export class CdsConfig {
	maxFixtureBatchSize: number;
}

export function cdsConfigFactory(service: ClientConfigService): CdsConfig {
	return service.get(CdsConfig);
}

@ClientConfig({ key:'msClickInteraction' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: clickInteractionConfigurationFactory,
})
export class ClickInteractionConfiguration {
	isEnabled: boolean;
}

export function clickInteractionConfigurationFactory(service: ClientConfigService): ClickInteractionConfiguration {
	return service.get(ClickInteractionConfiguration);
}

@ClientConfig({ key:'msClientCaching' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: clientCachingConfigFactory,
})
export class ClientCachingConfig {
	coreNavigationCompetitionListTimeout: number;
	couponListTimeout: number;
	liveSportListTimeout: number;
	productMenuTimeout: number;
	quicklinkCountsTimeout: number;
	regionListTimeout: number;
	sportListTimeout: number;
	sportTimeout: number;
}

export function clientCachingConfigFactory(service: ClientConfigService): ClientCachingConfig {
	return service.get(ClientCachingConfig);
}

@ClientConfig({ key:'msCompetitionTree' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: competitionTreeConfigFactory,
})
export class CompetitionTreeConfig {
	showCountDsl: boolean;
}

export function competitionTreeConfigFactory(service: ClientConfigService): CompetitionTreeConfig {
	return service.get(CompetitionTreeConfig);
}

@ClientConfig({ key:'msComposable' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: composableConfigFactory,
})
export class ComposableConfig {
	numberOfEventsOnShowMoreClick: number;
	thresholdToExpandAccordion: number;
}

export function composableConfigFactory(service: ClientConfigService): ComposableConfig {
	return service.get(ComposableConfig);
}

@ClientConfig({ key:'msConnection' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: connectionConfigFactory,
})
export class ConnectionConfig {
	cdsApiUrl: string;
	cdsFrontendUrl: string;
	cdsMaxRetries: number;
	cdsPrefferedTransportType: number;
	cdsPushTargetUrl: string;
	cdsPushUrl: string;
	cdsSkipNegotiation: boolean;
	cdsUrlBase?: string;
	culture: string;
	publicAccessId?: string;
	pushAccessId: string;
	shopTier?: number;
}

export function connectionConfigFactory(service: ClientConfigService): ConnectionConfig {
	return service.get(ConnectionConfig);
}

@ClientConfig({ key:'msCountryFlags' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: countryFlagsConfigFactory,
})
export class CountryFlagsConfig {
	countryFlagNames: Record<string, string | undefined>;
}

export function countryFlagsConfigFactory(service: ClientConfigService): CountryFlagsConfig {
	return service.get(CountryFlagsConfig);
}

@ClientConfig({ key:'msCrm' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: crmConfigFactory,
})
export class CrmConfig {
	promotions: CrmPromotionConfiguration;
	signposting: CrmPostBetSignpostingConfiguration;
	tokens: CrmTokenConfig;
}

export function crmConfigFactory(service: ClientConfigService): CrmConfig {
	return service.get(CrmConfig);
}

@ClientConfig({ key:'msCRMTokenImages' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: cRMTokenImagesFactory,
})
export class CRMTokenImages {
	crmTokenImages: CRMTokenImage[];
}

export function cRMTokenImagesFactory(service: ClientConfigService): CRMTokenImages {
	return service.get(CRMTokenImages);
}

@ClientConfig({ key:'msCrossSell' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: crossSellConfigFactory,
})
export class CrossSellConfig {
	isKYCCheckEnabled: boolean;
	isLiveCasinoEnabled: boolean;
	liveCasinoMaxNumberOfCategories: number;
	liveCasinoMaxNumberOfGames: number;
	lobbyType: string;
}

export function crossSellConfigFactory(service: ClientConfigService): CrossSellConfig {
	return service.get(CrossSellConfig);
}

@ClientConfig({ key:'msCurrency' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: currencyConfigFactory,
})
export class CurrencyConfig {
	clientCurrencyFormat?: string;
	currencySymbolDisplayList: string[];
	showStakeCurrency: boolean;
}

export function currencyConfigFactory(service: ClientConfigService): CurrencyConfig {
	return service.get(CurrencyConfig);
}

@ClientConfig({ key:'msCustomerDnaBettingOffer' , product: ClientConfigProductName.SPORTS, reload: true })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: customerDnaBettingOfferConfigFactory,
})
export class CustomerDnaBettingOfferConfig {
	isEnabled: boolean;
}

export function customerDnaBettingOfferConfigFactory(service: ClientConfigService): CustomerDnaBettingOfferConfig {
	return service.get(CustomerDnaBettingOfferConfig);
}

@ClientConfig({ key:'msEarlyPayout' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: earlyPayoutConfigFactory,
})
export class EarlyPayoutConfig {
	autoCashOutMarginValue: number;
	autoCashoutSgpAllowedCompetitions: Record<number, number[] | undefined>;
	isAutoCashOutEnabled: boolean;
	isAutoCashOutHelpEnabled: boolean;
	isAutoCashOutNotificationEnabled: boolean;
	isEarlyPayoutEnabled: boolean;
	isEarlyPayoutPrecheckEnabled: boolean;
	isEarlyPayoutPushEnabled: boolean;
	isEarlyPayoutTACDialogueEnabled: boolean;
	showCashOutInfo: boolean;
	showUpsellModule: boolean;
	upsellModuleDuration: number;
}

export function earlyPayoutConfigFactory(service: ClientConfigService): EarlyPayoutConfig {
	return service.get(EarlyPayoutConfig);
}

@ClientConfig({ key:'msEpcot' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: epcotConfigFactory,
})
export class EpcotConfig {
	isEnabled: boolean;
	sitemapDrawerTooltipVisibilityCount: number;
}

export function epcotConfigFactory(service: ClientConfigService): EpcotConfig {
	return service.get(EpcotConfig);
}

@ClientConfig({ key:'msEventDetails' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: eventDetailsConfigFactory,
})
export class EventDetailsConfig {
	collapsibleChevron: boolean;
	defaultExpandedMarketsCount: number;
	enableCorrectScoreOptionGroupToggle: boolean;
	enableEventPageModular: boolean;
	enableHideBreadcrumbOnScroll: boolean;
	enableSitemapNavigation: boolean;
	enableV2LiveStats: boolean;
	headerNavigationScoreboard: Record<string, number[] | undefined>;
	isBetBuilderSignpostingBadgeEnabled: boolean;
	isHeaderSubNavigationEnabled: boolean;
	isNewScoreboardEnabled: boolean;
	isSuspendedSelectionVisibilityEnabled: boolean;
	liveSgpTooltipViewsThreshold: Record<string, number | undefined>;
	marketTemplatesWithThresholds: Record<string, string[] | undefined>;
	mediaSwitcherTabs: Record<string, Record<string, string[] | undefined> | undefined>;
	showInOverlay: boolean;
	siteMapTooltipViewsThreshold: number;
	tabBarTooltipViewsThreshold: number;
	teamIndicatorFallbackColors: string[];
}

export function eventDetailsConfigFactory(service: ClientConfigService): EventDetailsConfig {
	return service.get(EventDetailsConfig);
}

@ClientConfig({ key:'msEventSwitcher' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: eventSwitcherConfigFactory,
})
export class EventSwitcherConfig {
	isEnabled: boolean;
	toggleIconAllowedSports: number[];
}

export function eventSwitcherConfigFactory(service: ClientConfigService): EventSwitcherConfig {
	return service.get(EventSwitcherConfig);
}

@ClientConfig({ key:'msFavourites' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: favouritesConfigFactory,
})
export class FavouritesConfig {
	collapseSize: number;
	favouritesGridWidgetFixturesMaxCount: number;
	initialSize: number;
	isFavouriteSwipeEnabled: boolean;
	isFavouritesEnabled: boolean;
	isFavouritesGridWidgetEnabled: boolean;
	isLiveFavouritesEnabled: boolean;
	isLiveWidgetFavouritesEnabled: boolean;
	maxFavourites: number;
	maxWidgetFavourites: number;
	pageSize: number;
	showFavoriteIconOnFavoritesPage: boolean;
	toastMessageTimeOut: number;
}

export function favouritesConfigFactory(service: ClientConfigService): FavouritesConfig {
	return service.get(FavouritesConfig);
}

@ClientConfig({ key:'msFormCoupon' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: formCouponConfigFactory,
})
export class FormCouponConfig {
	quickSelectorButtons: number[];
}

export function formCouponConfigFactory(service: ClientConfigService): FormCouponConfig {
	return service.get(FormCouponConfig);
}

@ClientConfig({ key:'msGeolocation' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: geolocationConfigFactory,
})
export class GeolocationConfig {
	appUrl?: string;
	bootstrapAssetPaths: string[];
	coordinatorSettings: CoordinatorSettings;
	gdsFetchLocationUrl?: string;
	gdsUrl?: string;
	geoGuardAppUrl?: string;
	geoPollingUrlPath?: string;
	initialRetryInterval: number;
	installerSettings: InstallerSettings;
	isBetRestrictionEnabled: boolean;
	isGeolocationEnabled: boolean;
	isNDBSEnabled: boolean;
	isRetryButtonEnabled: boolean;
	logGenericFailureResults: boolean;
	retriableErrorCodes: number[];
	retryInterval: number;
	saveDeviceDetails: boolean;
	shouldCheckNativeGeoLocation: boolean;
}

export function geolocationConfigFactory(service: ClientConfigService): GeolocationConfig {
	return service.get(GeolocationConfig);
}

@ClientConfig({ key:'msGrid' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: gridConfigFactory,
})
export class GridConfig {
	areEmptyEventStatisticsVisible: boolean;
	collapseSize?: number;
	enableCompactEventScoreboard: boolean;
	enableSGPNavigationOverride: boolean;
	fallbackMarketOddsThreshold: number;
	fallbackMarketsEnabled: boolean;
	gameNotesMaxCount: number;
	goalAnimationTimeInterval: number;
	gridEventDisplayVersion: string;
	hideGridTitle: boolean;
	initialSize: number;
	is2way3wayEnabled: boolean;
	isAllMarketsLinkEnabled: boolean;
	isGameNotesLayoutEnabled: boolean;
	isGoalAnimationEnabled: number[];
	isLeagueChildPageDesign: boolean;
	isMarketPillsEnabled: boolean;
	isRegionalisedGridEnabled: boolean;
	isShortEventInHeaderEnabled: boolean;
	isSixPackLayoutEnabled: boolean;
	marketSwitcherPosition: MarketSwitcherPositionType;
	overriddenCompetitionLogo: SportCompetitionFormat[];
	pageSize: number;
	primaryNavigationType: PrimaryNavigationDisplayType;
	showMarketPillsOnboardingMessage: boolean;
	showMoreRowsThreshold: number;
	showParticipantLogoOrImage: boolean;
	showRedCardsInSoccer: boolean;
	verticalGridGroupIds: Record<string, VerticalGridGroupOption | undefined>;
}

export function gridConfigFactory(service: ClientConfigService): GridConfig {
	return service.get(GridConfig);
}

@ClientConfig({ key:'msGTM' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: gTMConfigFactory,
})
export class GTMConfig {
	delay: number;
	enabled: boolean;
}

export function gTMConfigFactory(service: ClientConfigService): GTMConfig {
	return service.get(GTMConfig);
}

@LazyClientConfig({ key:'msHaptics' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: hapticsConfigurationFactory,
})
export class HapticsConfiguration extends LazyClientConfigBase {
	actionWithPattern: Record<string, string | undefined>;
	isEnabled: boolean;
}

export function hapticsConfigurationFactory(service: LazyClientConfigService): HapticsConfiguration {
	return service.get(HapticsConfiguration);
}

@ClientConfig({ key:'msImages' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: imagesConfigFactory,
})
export class ImagesConfig {
	competitionLogoUrl: string;
	competitionLogos: SportCompetitionFormat[];
	headshotEnabledOptionGroups: Record<number, string[] | undefined>;
	imageQualityParams: ImageCompressionFormat;
	isCompetitionImageProfile: boolean;
	isLogoBackgroundEnabled: boolean;
	isParticipantImageEnabled: boolean;
	participantImageEnabledMarketTypes: Record<number, string[] | undefined>;
	participantImageUrl: string;
	participantLogoUrl: string;
	silkImageUrl: string;
}

export function imagesConfigFactory(service: ClientConfigService): ImagesConfig {
	return service.get(ImagesConfig);
}

@ClientConfig({ key:'msImgConfigurationData' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: imgConfigurationDataFactory,
})
export class ImgConfigurationData {
	blacklistedCompetitions: number[];
	hoursToShowImgAnimation: number;
	isEnabled: boolean;
	isVideoPlaybackEnabled: boolean;
	languageMapping: Record<string, string | undefined>;
	pitchConfiguration: Record<string, string | undefined>;
}

export function imgConfigurationDataFactory(service: ClientConfigService): ImgConfigurationData {
	return service.get(ImgConfigurationData);
}

@ClientConfig({ key:'msInternalFeatures' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: internalFeaturesConfigFactory,
})
export class InternalFeaturesConfig {
	isAutomationDebugEnabled: boolean;
	isBalanceLoggingEnabled: boolean;
	isBetplacementLoggingEnabled: boolean;
	isEPSDetailedLoggingEnabled: boolean;
}

export function internalFeaturesConfigFactory(service: ClientConfigService): InternalFeaturesConfig {
	return service.get(InternalFeaturesConfig);
}

@ClientConfig({ key:'msIntroPages' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: introPagesConfigFactory,
})
export class IntroPagesConfig {
	cookieName: string;
	id: string;
	slides: HeadlineModel[];
}

export function introPagesConfigFactory(service: ClientConfigService): IntroPagesConfig {
	return service.get(IntroPagesConfig);
}

@LazyClientConfig({ key:'msIsQuickDepositAllowedResult' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: isQuickDepositAllowedResultFactory,
})
export class IsQuickDepositAllowedResult extends LazyClientConfigBase {
	isQuickDepositAllowed: boolean;
}

export function isQuickDepositAllowedResultFactory(service: LazyClientConfigService): IsQuickDepositAllowedResult {
	return service.get(IsQuickDepositAllowedResult);
}

@ClientConfig({ key:'msLayoutNavigation' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: layoutNavigationConfigFactory,
})
export class LayoutNavigationConfig {
	bottomNavItemsMapping: Record<string, string | undefined>;
	hideMidSectionBreadCrumbItems: boolean;
	isDesktopTopNavigationCompact: boolean;
	isDynamicCategoryNavigationEnabled: boolean;
	topNavigationVersion: string;
	useCleanNavigation: boolean;
}

export function layoutNavigationConfigFactory(service: ClientConfigService): LayoutNavigationConfig {
	return service.get(LayoutNavigationConfig);
}

@ClientConfig({ key:'msLcpCandidate' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: lcpCandidateConfigFactory,
})
export class LcpCandidateConfig {
	isEnabled: boolean;
}

export function lcpCandidateConfigFactory(service: ClientConfigService): LcpCandidateConfig {
	return service.get(LcpCandidateConfig);
}

@LazyClientConfig({ key:'msLineSwitcher' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: lineSwitcherConfigFactory,
})
export class LineSwitcherConfig extends LazyClientConfigBase {
	disabledLeagues: number[];
	disabledSports: number[];
	isHelpBoxEnabled: boolean;
}

export function lineSwitcherConfigFactory(service: LazyClientConfigService): LineSwitcherConfig {
	return service.get(LineSwitcherConfig);
}

@ClientConfig({ key:'msLinkExternalAccount' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: linkExternalAccountConfigFactory,
})
export class LinkExternalAccountConfig {
	isEnabled: boolean;
}

export function linkExternalAccountConfigFactory(service: ClientConfigService): LinkExternalAccountConfig {
	return service.get(LinkExternalAccountConfig);
}

@ClientConfig({ key:'msLiveNavigation' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: liveNavigationConfigFactory,
})
export class LiveNavigationConfig {
	isEachWayMarketsTabEnabled: boolean;
	isLiveEventsNavigationEnabled: boolean;
	liveIndicatorType: LiveIndicatorType;
	loadingIndicatorDelay: number;
	pollingInterval: number;
	treshold: number;
}

export function liveNavigationConfigFactory(service: ClientConfigService): LiveNavigationConfig {
	return service.get(LiveNavigationConfig);
}

@ClientConfig({ key:'msLiveSection' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: liveSectionConfigFactory,
})
export class LiveSectionConfig {
	activeParticipantIconForSports: number[];
	allowedEsportsOnLiveNavigation: number[];
	hideFiltersForSportIds: number[];
	isPagingEnabled: boolean;
	liveEventsInfoForLeagueIds: number[];
	maxLiveEventsPerSport: number;
	maxUpcomingEventsPerSport: number;
	minEventsPagingSize: number;
	pageSize: number;
	showLiveBadgeCount: string[];
}

export function liveSectionConfigFactory(service: ClientConfigService): LiveSectionConfig {
	return service.get(LiveSectionConfig);
}

@ClientConfig({ key:'msLobby' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: lobbyConfigFactory,
})
export class LobbyConfig {
	homePageGridsRefreshTimeout: number;
	homePageRefreshTimeout: number;
	liveSectionNumberOfEventsPerSport: number;
	liveSectionNumberOfSports: number;
	mainSectionNumberOfEventsPerSport: number;
	mainSectionNumberOfSports: number;
	orderedRenderingTimeout: number;
	sportToEsportsMapping: Record<number, number[] | undefined>;
	topPageRefreshTimeout: number;
}

export function lobbyConfigFactory(service: ClientConfigService): LobbyConfig {
	return service.get(LobbyConfig);
}

@ClientConfig({ key:'msMarketGrouping' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: marketGroupingConfigFactory,
})
export class MarketGroupingConfig {
	correctScoreOptionsSortOrder?: string;
	displayTypes: string[];
	enablePlayerMilestoneByMarketSubType: boolean;
	eventCarouselVisibilityConfig: EventCarouselVisibilityConfig[];
	isOverUnderAbbreviationEnabled: boolean;
	marketGroupsWithNewBadge: MarketGroupsWithNewBadge[];
	milestoneMarketsDefaultTab: Record<string, number | undefined>;
	optionCollapseSize: OptionPanelThreshold[];
	optionGroupRowsThreshold: OptionGroupRowsThreshold;
	optionGroupWithPlayerData: string[];
	optionTypesToFilterTV2MarketOptions: OptionTypesToFilterTV2MarketOptions[];
	orderByLineValue: boolean;
	outrightsGroupMaxNumberOfLines: number;
	overUnderGroupMaxNumberOfLines: number;
	overrideParticipantNameOptionMarkets: OverrideParticipantNameOptionMarkets[];
	playerCombinedGroupMaxLines: number;
	playerMilestoneGroupMaxLines: number;
	playerPropsGroupMaxNumberOfLines: number;
	playerStatsEnabledOptionGroup: Record<string, string[] | undefined>;
	raceToGroupMaxNumberOfLines: number;
	regionalisedGroupingEnabled: boolean;
	scorecastPossibleWinningsVisible: boolean;
	scorecastRegexValues: ScorecastRegexValues;
	scorecastSelectionCacheDurationMs: number;
	seasonStatsEnabledOptionGroup: Record<number, string[] | undefined>;
	shouldShowLineValueInSquares: boolean;
	shouldShowSheetViewForAllMarkets: boolean;
	showMarketHelpTextAsBlurb: Record<number, string[] | undefined>;
	showMoreBetBuilderCorrectScoreThreshold: number;
	showMoreCorrectScoreThreshold: number;
	showMoreRegularThreshold: number;
	spreadGroupMaxNumberOfLines: number;
	teamGroupingMaxNumberOfLines: number;
	teamGroupingTabVisibilityThreshold: number;
	templateIdsForSecondChanceBadge: number[];
	useMarketGroupSortingByStage: boolean;
}

export function marketGroupingConfigFactory(service: ClientConfigService): MarketGroupingConfig {
	return service.get(MarketGroupingConfig);
}

@ClientConfig({ key:'msMarketHelp' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: marketHelpConfigFactory,
})
export class MarketHelpConfig {
	enabled: boolean;
	marketHelpCacheTimeout: number;
	marketHelpTextDisplayVersion: string;
	sitecoreFallbackItem: string;
}

export function marketHelpConfigFactory(service: ClientConfigService): MarketHelpConfig {
	return service.get(MarketHelpConfig);
}

@ClientConfig({ key:'msMarketSlider' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: marketSliderConfigurationFactory,
})
export class MarketSliderConfiguration {
	activationThreshold: number;
	enableForSpread: boolean;
	enableForTotal: boolean;
}

export function marketSliderConfigurationFactory(service: ClientConfigService): MarketSliderConfiguration {
	return service.get(MarketSliderConfiguration);
}

@ClientConfig({ key:'msMarquee' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: marqueeConfigFactory,
})
export class MarqueeConfig {
	automatedMarqueesOrder: string[];
	automatedRegularMarqueesOrder: Record<string, string[] | undefined>;
	disabledSportIds: number[];
	dynamicMarkets: string[];
	isAutomatedMarqueesEnabled: boolean;
	isFallbackMarqueeEnabled: boolean;
	isHighlightsMarqueeEnabled: boolean;
	mapMarketToGameTemplateIds: MapMarketToGameTemplateIds[];
	marketListWithOptionDropdown: string[];
	marqueeGroupsOfMarkets: MarqueeGroupsOfMarkets[];
	marqueeMarketOverrides: Record<string, string | undefined>;
	marqueeVariant: MarqueeVariantVersions;
	maxCorrectScoreGoals: number;
	maxMarketsToShowInOptionDropdown: number;
	maxRequestedEvents: number;
	maxTiles: number;
	oddThresholdValue: number;
	scrollingSpeed: Record<string, string | undefined>;
	showTooltipForLockedOdds: boolean;
	sixPackGridGroupMapping: SixPackGridGroupMapping[];
	specialLeagueIds: number[];
}

export function marqueeConfigFactory(service: ClientConfigService): MarqueeConfig {
	return service.get(MarqueeConfig);
}

@LazyClientConfig({ key:'msMarqueeTiles' , product: ClientConfigProductName.SPORTS, reload: true })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: marqueeTilesConfigFactory,
})
export class MarqueeTilesConfig extends LazyClientConfigBase {
	tiles: MarqueeTile[];
}

export function marqueeTilesConfigFactory(service: LazyClientConfigService): MarqueeTilesConfig {
	return service.get(MarqueeTilesConfig);
}

@ClientConfig({ key:'msMatchList' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: matchListConfigFactory,
})
export class MatchListConfig {
	maxEventThreshold: number;
	showLoader: boolean;
}

export function matchListConfigFactory(service: ClientConfigService): MatchListConfig {
	return service.get(MatchListConfig);
}

@ClientConfig({ key:'msMedia' , product: ClientConfigProductName.SPORTS, reload: true })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: mediaConfigFactory,
})
export class MediaConfig {
	contentPlayerProEnabledSports: number[];
	enableDefaultMediaTabByStreamType: boolean;
	expandedMediaEnabledLocations: string[];
	isExpandedMediaEnabled: boolean;
	isMatchSimulationEnabled: boolean;
	isVideoStreamFullscreenEnabled: boolean;
	matchSimulation: MatchSimulationConfiguration;
	performMappings: PerformMappingsConfiguration;
	performV2LiveStreamLaunchUrl: string;
	restrictedSportIds: number[];
	showScoreboardCommentaryFeed: boolean;
	showStatsCenterButton: boolean;
	showVideoStreaming: boolean;
	sportsWithMatchSimulation: number[];
	subdivisionRestrictedCountries: string[];
	twitchPlayerLibraryUrl: string;
	videoStreamGeoCoordinatesCountries: string[];
	videoUrlRefreshInterval: Record<string, number | undefined>;
}

export function mediaConfigFactory(service: ClientConfigService): MediaConfig {
	return service.get(MediaConfig);
}

@LazyClientConfig({ key:'msMobileConfirmationNotificationClient' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: mobileConfirmationNotificationClientConfigFactory,
})
export class MobileConfirmationNotificationClientConfig extends LazyClientConfigBase {
	confirmationIntervalMilliseconds: number;
	isEnabled: boolean;
}

export function mobileConfirmationNotificationClientConfigFactory(service: LazyClientConfigService): MobileConfirmationNotificationClientConfig {
	return service.get(MobileConfirmationNotificationClientConfig);
}

@ClientConfig({ key:'msMocks' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: mocksConfigFactory,
})
export class MocksConfig {
	isMockLiveStreamGeoCountryEnabled: boolean;
	liveStreamGeoCountry?: string;
}

export function mocksConfigFactory(service: ClientConfigService): MocksConfig {
	return service.get(MocksConfig);
}

@ClientConfig({ key:'msMsPage' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: msPageFactory,
})
export class MsPage {
	title?: string;
}

export function msPageFactory(service: ClientConfigService): MsPage {
	return service.get(MsPage);
}

@LazyClientConfig({ key:'msMultiBuilder' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: multiBuilderConfigFactory,
})
export class MultiBuilderConfig extends LazyClientConfigBase {
	cacheTimeOut: number;
	competitionOrder: Record<number, number | undefined>;
	isEnabled: boolean;
	marketGridGroups: MarketGridGroup[];
	maxCompetitionsCount: number;
	maxFixturesCount: number;
	showStats: boolean;
}

export function multiBuilderConfigFactory(service: LazyClientConfigService): MultiBuilderConfig {
	return service.get(MultiBuilderConfig);
}

@LazyClientConfig({ key:'msMultiSportsHub' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: multiSportsHubConfigFactory,
})
export class MultiSportsHubConfig extends LazyClientConfigBase {
	isEnabled: boolean;
}

export function multiSportsHubConfigFactory(service: LazyClientConfigService): MultiSportsHubConfig {
	return service.get(MultiSportsHubConfig);
}

@LazyClientConfig({ key:'msMyBetsBetstation' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: myBetsBetstationConfigFactory,
})
export class MyBetsBetstationConfig extends LazyClientConfigBase {
	delayForPayoutStatusCheckAfterCashout: number;
	intervalForPayoutVerifyCalls: number;
	myBetsPageSize: number;
	openBetReloadDataInterval: number;
	payoutVerifyRetryAttemps: number;
	timeOutToHideBetAfterCashout: number;
}

export function myBetsBetstationConfigFactory(service: LazyClientConfigService): MyBetsBetstationConfig {
	return service.get(MyBetsBetstationConfig);
}

@ClientConfig({ key:'msMyBets' , product: ClientConfigProductName.SPORTS, reload: true })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: myBetsConfigFactory,
})
export class MyBetsConfig {
	archivedMyBetsUrl?: string;
	cacheTimeout: number;
	defaultDaysBeforeMigrationDate: number;
	earlyPayoutButtonResetTime: string;
	editMyBetTimeout: number;
	enableBalanceRefresh: boolean;
	enablePinning: boolean;
	enableRedesignedBetCard: boolean;
	enableSGPRepricedOdds: boolean;
	enableTwoLinePickInfo: boolean;
	exportButtonType: IExportButtonType;
	hideBottomNavMyBetsIndicator: boolean;
	isArchivedBetsEnabled: boolean;
	isCondensedScoreboardEnabled: boolean;
	isEditMyBetEnabled: boolean;
	isIndicatorConnectorEnabled: boolean;
	isMyBetTabRedesignEnabled: boolean;
	isOpenSummaryLoadingRestricted: boolean;
	isOpenTabSortingEnabled: boolean;
	isShareMyBetOnelinkEnabled: boolean;
	isShowOpenBetsCount: boolean;
	isTransactionBetsEnabled: boolean;
	liveBetStatusTrackingMarkets: Record<number, string[] | undefined>;
	liveBetsRefreshInterval: string;
	maxPins: number;
	myBetsRefreshInMilliseconds: number;
	pageSize: number;
	printBetsThresholdForApp: number;
	reloadMyBetsTimeInterval: number;
	showAssociatedAccount: boolean;
	showBetTypeAsBadge: boolean;
	showBrowseSportsBook: boolean;
	showGridScoreBoardConfig: MyBetsGridScoreBoardConfigResponse;
	showNetWinnings: boolean;
	showRegionCode: boolean;
	showSportAndCompetitionName: boolean;
	stadiumMyBetsTransactionsUrl?: string;
	useOpenBetsPostRequest: boolean;
}

export function myBetsConfigFactory(service: ClientConfigService): MyBetsConfig {
	return service.get(MyBetsConfig);
}

@LazyClientConfig({ key:'msMyBetsVisualizationTracking' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: myBetsVisualizationTrackingConfigFactory,
})
export class MyBetsVisualizationTrackingConfig extends LazyClientConfigBase {
	allowedLeagues: Record<number, number[] | undefined>;
	allowedSportByStats: Record<string, number[] | undefined>;
	isEnabled: boolean;
	marketTemplateMapping: Record<number, Record<string, number[] | undefined> | undefined>;
	marketTypeMapping: Record<number, Record<string, string[] | undefined> | undefined>;
	targetStatForMarket: Record<number, number[] | undefined>;
}

export function myBetsVisualizationTrackingConfigFactory(service: LazyClientConfigService): MyBetsVisualizationTrackingConfig {
	return service.get(MyBetsVisualizationTrackingConfig);
}

@LazyClientConfig({ key:'msNativeAlerts' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: nativeAlertsConfigFactory,
})
export class NativeAlertsConfig extends LazyClientConfigBase {
	appNotificationsEnabledCheck: boolean;
	enabled: boolean;
	enabledAccessPoints: string[];
	fetchingInterval: number;
	sports: SportConfiguration[];
}

export function nativeAlertsConfigFactory(service: LazyClientConfigService): NativeAlertsConfig {
	return service.get(NativeAlertsConfig);
}

@ClientConfig({ key:'msNewCustomerBettingOffer' , product: ClientConfigProductName.SPORTS, reload: true })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: newCustomerBettingOfferConfigFactory,
})
export class NewCustomerBettingOfferConfig {
	competitionId?: number;
}

export function newCustomerBettingOfferConfigFactory(service: ClientConfigService): NewCustomerBettingOfferConfig {
	return service.get(NewCustomerBettingOfferConfig);
}

@LazyClientConfig({ key:'msNextToGo' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: nextToGoConfigFactory,
})
export class NextToGoConfig extends LazyClientConfigBase {
	intervalForRedPreMatchTimer: number;
	marketGridGroupIds: NextToGoGroupsOfMarkets[];
	maxEventsPerSport: number;
	minEventsPerSport: number;
	module: NextToGoModule;
	showOdds: boolean;
	showParticipantLogoOrImage: boolean;
	sportsToDisplayCompetitionLogo: number[];
	timeFrame: number;
}

export function nextToGoConfigFactory(service: LazyClientConfigService): NextToGoConfig {
	return service.get(NextToGoConfig);
}

@ClientConfig({ key:'msNgrxReports' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: ngrxReportsConfigurationFactory,
})
export class NgrxReportsConfiguration {
	actionsUpdateThreshold: number;
	isReportsEnabled: boolean;
	maxActions: number;
	restrictedActions: string[];
}

export function ngrxReportsConfigurationFactory(service: ClientConfigService): NgrxReportsConfiguration {
	return service.get(NgrxReportsConfiguration);
}

@LazyClientConfig({ key:'msNotifications' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: notificationsConfigFactory,
})
export class NotificationsConfig extends LazyClientConfigBase {
	appBetNotificationsDisabledForSports: DisabledNotificationSport[];
	emailDisabledForSports: DisabledNotificationSport[];
	isAppBetNotificationsEnabled: boolean;
	isEmailBetNotificationsEnabled: boolean;
}

export function notificationsConfigFactory(service: LazyClientConfigService): NotificationsConfig {
	return service.get(NotificationsConfig);
}

@ClientConfig({ key:'msOdds' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: oddsConfigFactory,
})
export class OddsConfig {
	allowedOddsFormats: OddsDisplayFormat[];
	display: OddsDisplayConfiguration;
	displayOddsChangePreferencePopup: boolean;
	hideDontAcceptOptionSetting: boolean;
	oddsAcceptanceTeaserThreshold: number;
	oddsChangePopupEligibilityDate?: string;
	preferencesReminder: BetslipOddsPreferencesReminderConfiguration;
	showOddsAcceptanceSettings: boolean;
}

export function oddsConfigFactory(service: ClientConfigService): OddsConfig {
	return service.get(OddsConfig);
}

@ClientConfig({ key:'msOddsFormatSettings' , product: ClientConfigProductName.SPORTS, reload: true })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: oddsFormatSettingsFactory,
})
export class OddsFormatSettings {
	generalOddsFormat: OddsDisplayFormat;
}

export function oddsFormatSettingsFactory(service: ClientConfigService): OddsFormatSettings {
	return service.get(OddsFormatSettings);
}

@ClientConfig({ key:'msOutrightsGrid' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: outrightsGridConfigFactory,
})
export class OutrightsGridConfig {
	enableParticipantImages: number[];
	isEnabled: boolean;
	isMarketPillsEnabled: boolean;
	maxCompetitions: number;
	maxRowsThreshold: number;
	overrideParticipantImageNameFormat: ParticipantImageFormat[];
	showParticipantLogo: boolean;
}

export function outrightsGridConfigFactory(service: ClientConfigService): OutrightsGridConfig {
	return service.get(OutrightsGridConfig);
}

@LazyClientConfig({ key:'msOverAsk' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: overAskConfigFactory,
})
export class OverAskConfig extends LazyClientConfigBase {
	disableNewStakeHint: boolean;
	pauseThreshold: number;
	pendingShouldShowPercentage: boolean;
	reviewProgressbarTotalSteps: number;
	reviewWaitingTime: number;
	showStakeChanges: boolean;
}

export function overAskConfigFactory(service: LazyClientConfigService): OverAskConfig {
	return service.get(OverAskConfig);
}

@ClientConfig({ key:'msOverrideStatistics' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: overrideStatisticsConfigFactory,
})
export class OverrideStatisticsConfig {
	teamRankings: Record<number, Record<number, Record<number, number | undefined> | undefined> | undefined>;
}

export function overrideStatisticsConfigFactory(service: ClientConfigService): OverrideStatisticsConfig {
	return service.get(OverrideStatisticsConfig);
}

@ClientConfig({ key:'msParticipants' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: participantsConfigFactory,
})
export class ParticipantsConfig {
	enabledShortNames: Record<number, Record<number, string[] | undefined> | undefined>;
}

export function participantsConfigFactory(service: ClientConfigService): ParticipantsConfig {
	return service.get(ParticipantsConfig);
}

@ClientConfig({ key:'msPerformanceProfiling' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: performanceProfilingConfigFactory,
})
export class PerformanceProfilingConfig {
	isPerformanceProfilingEnabled: boolean;
}

export function performanceProfilingConfigFactory(service: ClientConfigService): PerformanceProfilingConfig {
	return service.get(PerformanceProfilingConfig);
}

@ClientConfig({ key:'msPersonalizedMarquee' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: personalizedMarqueeConfigFactory,
})
export class PersonalizedMarqueeConfig {
	checkABUserCookie: boolean;
	enablePersonalizedMarquee: boolean;
	minEventsToShow: number;
	showOnlyPersonalizedMarquees: boolean;
}

export function personalizedMarqueeConfigFactory(service: ClientConfigService): PersonalizedMarqueeConfig {
	return service.get(PersonalizedMarqueeConfig);
}

@LazyClientConfig({ key:'msPlayerStatistics' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: playerStatisticsConfigFactory,
})
export class PlayerStatisticsConfig extends LazyClientConfigBase {
	playerStatisticsInfo: PlayerStatisticsInfo;
	playerStatisticsMessages: PlayerStatisticsMessages;
	seasonStatisticsMessages: SeasonStatisticsMessages;
}

export function playerStatisticsConfigFactory(service: LazyClientConfigService): PlayerStatisticsConfig {
	return service.get(PlayerStatisticsConfig);
}

@LazyClientConfig({ key:'msPopularBets' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: popularBetsConfigFactory,
})
export class PopularBetsConfig extends LazyClientConfigBase {
	betBuilderPodStylingOverride: boolean;
	bufferTimeToIgnoreLiveEvents: number;
	defaultButtonOverride: boolean;
	isMarketNameEnabled: Record<PopularBetsPodTypes, boolean | undefined>;
	isMultiBetsModuleEnabled: boolean;
	isOpponentNameEnabled: Record<PopularBetsPodTypes, boolean | undefined>;
	isTeamLogoEnabled: boolean;
	logoConfigurationForPodType: Record<string, string[] | undefined>;
	marketOptionStyling: boolean;
	minCountForShowingCounter: number;
	popularBetsStylingOverride: boolean;
	timeFrame: number;
}

export function popularBetsConfigFactory(service: LazyClientConfigService): PopularBetsConfig {
	return service.get(PopularBetsConfig);
}

@ClientConfig({ key:'msPopularSearchData' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: popularSearchDataFactory,
})
export class PopularSearchData {
	popularList: PopularSearchModel[];
}

export function popularSearchDataFactory(service: ClientConfigService): PopularSearchData {
	return service.get(PopularSearchData);
}

@ClientConfig({ key:'msPopups' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: popupsConfigFactory,
})
export class PopupsConfig {
	closeButtonType: string;
	slidesFromBottom: Record<string, boolean | undefined>;
	slidesFromRight: Record<string, boolean | undefined>;
}

export function popupsConfigFactory(service: ClientConfigService): PopupsConfig {
	return service.get(PopupsConfig);
}

@LazyClientConfig({ key:'msPostBetSignposting' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: postBetSignpostingConfigFactory,
})
export class PostBetSignpostingConfig extends LazyClientConfigBase {
	awardTypeMapping: Record<string, AwardTypeParameters | undefined>;
	isEnabled: boolean;
}

export function postBetSignpostingConfigFactory(service: LazyClientConfigService): PostBetSignpostingConfig {
	return service.get(PostBetSignpostingConfig);
}

@ClientConfig({ key:'msPrematchNavigation' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: prematchNavigationConfigFactory,
})
export class PrematchNavigationConfig {
	isPrematchEventsNavigationEnabled: boolean;
	pollingInterval: number;
	treshold: number;
}

export function prematchNavigationConfigFactory(service: ClientConfigService): PrematchNavigationConfig {
	return service.get(PrematchNavigationConfig);
}

@ClientConfig({ key:'msPrettyUrls' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: prettyUrlsConfigFactory,
})
export class PrettyUrlsConfig {
	maxTokenLength: number;
	tokenSanitizer: string;
	translations: UrlTranslation;
}

export function prettyUrlsConfigFactory(service: ClientConfigService): PrettyUrlsConfig {
	return service.get(PrettyUrlsConfig);
}

@LazyClientConfig({ key:'msPreviousPageLocation' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: previousPageLocationConfigurationFactory,
})
export class PreviousPageLocationConfiguration extends LazyClientConfigBase {
	caheTimeOut: number;
	enabled: boolean;
}

export function previousPageLocationConfigurationFactory(service: LazyClientConfigService): PreviousPageLocationConfiguration {
	return service.get(PreviousPageLocationConfiguration);
}

@ClientConfig({ key:'msPriceBoost' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: priceBoostConfigFactory,
})
export class PriceBoostConfig {
	fixturesPageSize: number;
	isEnabled: boolean;
	isEnabledAPB: boolean;
	maxGroupOptions: number;
	showAsTab: boolean;
	showCount: boolean;
	showCountForLive: boolean;
}

export function priceBoostConfigFactory(service: ClientConfigService): PriceBoostConfig {
	return service.get(PriceBoostConfig);
}

@ClientConfig({ key:'msQuickBet' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: quickBetConfigFactory,
})
export class QuickBetConfig {
	hideActionButtonsOnEmptyStake: boolean;
	isAddToBetslipCtaTextEnabled: boolean;
	isClearCtaTextEnabled: boolean;
	isContextualInfoEnabled: boolean;
	isEnabled: boolean;
	isEnhancedStakeEnabled: boolean;
	isHeaderEnabled: boolean;
	isPossibleWinningsUnderStakeInputEnabled: boolean;
	isQuickBetParlayEnabled: boolean;
	isTotalReturnsEnabled: boolean;
	isUserBalanceEnabled: boolean;
	showOnAllPages: boolean;
	showOnEventDetails: boolean;
	showOnLivePage: boolean;
	showOnMyBets: boolean;
}

export function quickBetConfigFactory(service: ClientConfigService): QuickBetConfig {
	return service.get(QuickBetConfig);
}

@ClientConfig({ key:'msQuickDeposit' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: quickDepositConfigFactory,
})
export class QuickDepositConfig {
	isPaymentsLibraryEnabled: boolean;
	isQuickDepositEnabled: boolean;
	loadQuickDepositConfigOnLogin: boolean;
	path: string;
	url?: string;
}

export function quickDepositConfigFactory(service: ClientConfigService): QuickDepositConfig {
	return service.get(QuickDepositConfig);
}

@LazyClientConfig({ key:'msQuickLinks' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: quickLinksFactory,
})
export class QuickLinks extends LazyClientConfigBase {
	layout: LinkListLayout;
	links: QuickLinkViewModel[];
}

export function quickLinksFactory(service: LazyClientConfigService): QuickLinks {
	return service.get(QuickLinks);
}

@ClientConfig({ key:'msRacing' , product: ClientConfigProductName.SPORTS, reload: true })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: racingConfigFactory,
})
export class RacingConfig {
	bogTodayThresholdTime: string;
	bogVersion: BogVersion;
	canBogTokenBeUsedWithFreebetToken: boolean;
	countdownTimer: number;
	easyBetViewOptions: HorseRacingEasyBetViewOption[];
	enabledTabs: Record<number, string[] | undefined>;
	filterRegionIds: string;
	greyhoundsEasyBetViewOptions: GreyhoundsRacingEasyBetViewOption[];
	isBOGEnabled: boolean;
	isGreyhoundsEnabled: boolean;
	maxPromos: number;
	maxPromosForMobile: number;
	minPromos: number;
	minPromosForMobile: number;
	nextFixturesCount: number;
	refreshInterval: number;
	showAllRaces: boolean;
}

export function racingConfigFactory(service: ClientConfigService): RacingConfig {
	return service.get(RacingConfig);
}

@LazyClientConfig({ key:'msRacingPromos' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: racingPromosFactory,
})
export class RacingPromos extends LazyClientConfigBase {
	promos: MarketingViewModel[];
}

export function racingPromosFactory(service: LazyClientConfigService): RacingPromos {
	return service.get(RacingPromos);
}

@LazyClientConfig({ key:'msRandomMultiGenerator' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: randomMultiGeneratorConfigFactory,
})
export class RandomMultiGeneratorConfig extends LazyClientConfigBase {
	autoSpinningInterval: number;
	defaultMaxOdds: number;
	defaultMinOdds: number;
	defaultMinWinnings: number;
	defaultSelections: number;
	defaultStake: number;
	historyLength: number;
	isEnabled: boolean;
	marketMapping: Record<number, MarketMappingConfiguration[] | undefined>;
	maxSelections: number;
	minOddsFallback: number;
	minSelections: number;
	oddsRange: number[];
	possibleWinningsRange: number[];
	sports: RandomMultiGeneratorSportsSelection;
	sportsConfig: RandomMultiGeneratorSportsConfig[];
}

export function randomMultiGeneratorConfigFactory(service: LazyClientConfigService): RandomMultiGeneratorConfig {
	return service.get(RandomMultiGeneratorConfig);
}

@ClientConfig({ key:'msRealityCheck' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: realityCheckConfigFactory,
})
export class RealityCheckConfig {
	cookieName: string;
	jurisdictions: string[];
	realityCheckEvent: string;
	updateInterval: number;
}

export function realityCheckConfigFactory(service: ClientConfigService): RealityCheckConfig {
	return service.get(RealityCheckConfig);
}

@ClientConfig({ key:'msReBet' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: reBetConfigFactory,
})
export class ReBetConfig {
	ctaDescriptionEnabledTabs: string[];
	ctaSubtitleEnabledTabs: string[];
	enabledTabs: string[];
	helpBoxEnabledTabs: string[];
	isCtaConsistencyEnabled: boolean;
}

export function reBetConfigFactory(service: ClientConfigService): ReBetConfig {
	return service.get(ReBetConfig);
}

@ClientConfig({ key:'msRegionalQuickLinks' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: regionalQuickLinksConfigFactory,
})
export class RegionalQuickLinksConfig {
	betConfirmationLinks: QuickLinkViewModel[];
	emptyBetslipLinks: QuickLinkViewModel[];
}

export function regionalQuickLinksConfigFactory(service: ClientConfigService): RegionalQuickLinksConfig {
	return service.get(RegionalQuickLinksConfig);
}

@ClientConfig({ key:'msRegions' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: regionsConfigFactory,
})
export class RegionsConfig {
	listOfLeaguesToHideRegionName: number[];
	listOfRegionsToHideRegionName: number[];
	regionNames: string[];
}

export function regionsConfigFactory(service: ClientConfigService): RegionsConfig {
	return service.get(RegionsConfig);
}

@ClientConfig({ key:'msReturnsMessage' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: returnsMessageConfigFactory,
})
export class ReturnsMessageConfig {
	defaultStakes: Record<string, number | undefined>;
	persistenceTime: number;
}

export function returnsMessageConfigFactory(service: ClientConfigService): ReturnsMessageConfig {
	return service.get(ReturnsMessageConfig);
}

@LazyClientConfig({ key:'msScoreboardBackground' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: scoreboardBackgroundConfigFactory,
})
export class ScoreboardBackgroundConfig extends LazyClientConfigBase {
	backgrounds: ScoreboardBackground[];
}

export function scoreboardBackgroundConfigFactory(service: LazyClientConfigService): ScoreboardBackgroundConfig {
	return service.get(ScoreboardBackgroundConfig);
}

@ClientConfig({ key:'msScrollingSize' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: scrollingSizeConfigFactory,
})
export class ScrollingSizeConfig {
	hideHeaderOnScroll: string[];
	marqueeScrollSize: number;
	regionScrollSize: number;
	scrollThreshold: number;
	scrollingSpeed: Record<string, number | undefined>;
	sportScrollSize: number;
	topNavScrollSize: number;
}

export function scrollingSizeConfigFactory(service: ClientConfigService): ScrollingSizeConfig {
	return service.get(ScrollingSizeConfig);
}

@ClientConfig({ key:'msSeo' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: seoConfigFactory,
})
export class SeoConfig {
	clientLoggingDebounce: number;
	isClientCatchallLoggingEnabled: boolean;
	removeHrefToEventForRobot: boolean;
}

export function seoConfigFactory(service: ClientConfigService): SeoConfig {
	return service.get(SeoConfig);
}

@ClientConfig({ key:'msShareMyBet' , product: ClientConfigProductName.SPORTS, reload: true })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: shareMyBetConfigFactory,
})
export class ShareMyBetConfig {
	complianceCookieExpiryDays: number;
	globalErrorVisibilityTime: number;
	isEnabled: boolean;
	isHelpBoxEnabled: boolean;
	isNewBadgeEnabled: boolean;
	isOnboardingEnabled: boolean;
	oneLinkConfig: OneLinkConfig;
	showBetSharingConfirmationOnlyOnFirstBetShare: boolean;
}

export function shareMyBetConfigFactory(service: ClientConfigService): ShareMyBetConfig {
	return service.get(ShareMyBetConfig);
}

@ClientConfig({ key:'msShowcase' , product: ClientConfigProductName.SPORTS, reload: true })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: showcaseConfigFactory,
})
export class ShowcaseConfig {
	alternateMarkets: Record<string, string | undefined>;
	backgrounds: BackgroundImage[];
	enabledSportIds: number[];
	isShowcaseModuleEnabled: boolean;
	items: ShowcaseViewModel[];
	marketGridGroupIds: ShowcaseGroupsOfMarkets[];
	nextGoalMarketGroupId: string;
	sixPackSportTypeIds: number[];
}

export function showcaseConfigFactory(service: ClientConfigService): ShowcaseConfig {
	return service.get(ShowcaseConfig);
}

@LazyClientConfig({ key:'msSitecore' , product: ClientConfigProductName.SPORTS, reload: true })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: sitecoreFactory,
})
export class Sitecore extends LazyClientConfigBase {
	accaBoost: SitecoreAccaBoost;
	betBuilder: BetBuilder;
	betBuilderEntainUI: BetBuilderEntainUI;
	betBuilderHelpPage: BetBuilderHelpPage;
	betBuilderSignposting: BetBuilderSignposting;
	betFinder: BetFinder;
	betStation?: BetStation;
	betslip: Betslip;
	betslipSettings: BetslipSettings;
	betslipUpsell: BetslipUpsell;
	bettingPreferences: BettingPreferences;
	cashoutSettings: CashoutSettings;
	contentMessages: ContentMessages;
	couponTags: CouponTags;
	coupons: Coupons;
	crmPostBetSignposting: CrmPostBetSignposting;
	crmPromotions: CrmPromotions;
	crmPromotionsBanners: CrmPromotionsBanners;
	crmTokens: CrmTokens;
	eSports: ESportsConfig;
	earlyPayout: EarlyPayout;
	earlyPayoutErrors: EarlyPayoutErrors;
	earlyPayoutPushErrors: EarlyPayoutPushErrorItem[];
	earlyPayoutSettings: EarlyPayoutSettings;
	earlyPayoutV2: EarlyPayoutV2;
	event: Event;
	eventGameNotes: EventGameNotes;
	eventGrid: EventGrid;
	eventGridMarketHeaders: EventGridMarketHeaders;
	eventScoreboard: EventScoreboard;
	favouritesDashboard: FavouritesDashboard;
	favouritesMessages: FavouritesMessages;
	fixture: Fixture;
	formCoupon: FormCoupon;
	freeBetOverview: FreeBetOverview;
	geoLocation: GeoLocation;
	globalMessages: GlobalMessages;
	greyhoundRacing: GreyHoundRacing;
	horseRacing: HorseRacing;
	linkExternalAccounts: LinkExternalAccounts;
	links: Record<string, LinkTemplateForClient | undefined>;
	liveAnimation: LiveAnimation;
	liveNavigation: LiveNavigation;
	liveSportsVisualizationTranslation: LiveSportsVisualizationTranslation;
	lobby: Lobby;
	marketHelp: MarketHelp;
	marketSubtypeLogo: MarketSubtypeLogo;
	marquee: Marquee;
	media: Media;
	media_NotLoggedin: Media_NotLoggedin;
	menus: Menus;
	modalDialogs: ModalDialogs;
	multiBuilder: MultiBuilder;
	multiRandomGenerator: MultiRandomGenerator;
	myBets: MyBets;
	myBets_FilterView: MyBetsFilterView;
	myBets_Print: MyBetsPrint;
	nativeAlerts?: NativeAlert;
	ngrxReports: NgrxReports;
	oddsDisplay: OddsDisplay;
	popularPicks: PopularPicks;
	quickBet: QuickBet;
	quickBetButtonStates: QuickBetButtonStates;
	quickBetHelp: QuickBetHelp;
	quickBetMessages: QuickBetMessages;
	quickBetModalDialog: QuickBetModalDialog;
	quickBetNumpad: QuickBetNumpad;
	reBet: ReBet;
	returnsMessage: ReturnsMessage;
	scoreboardPlayerStats: Record<string, Record<string, string | undefined> | undefined>;
	scoreboardPointsOmit: number[];
	seo: Seo;
	shareMyBet: ShareMyBet;
	showcaseMessages: ShowcaseMessages;
	stakeChanges: StakeChanges;
	statistics: SitecoreStatistics;
	systemBets: SystemBets;
	teamGrouping: TeamGrouping;
	toastLiveNotifications: ToastLiveNotifications;
	toastNotifications: ToastNotifications;
	widgets: Widgets;
	panicButtonMessages: PanicButtonMessages;
}

export function sitecoreFactory(service: LazyClientConfigService): Sitecore {
	return service.get(Sitecore);
}

@LazyClientConfig({ key:'msSitecoreEventDetails' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: sitecoreEventDetailsConfigFactory,
})
export class SitecoreEventDetailsConfig extends LazyClientConfigBase {
	eventDetails: EventDetailsModel;
	onboarding: Record<string, string | undefined>;
	sitemapOrder?: EventDetailsSitemapDictionary[];
}

export function sitecoreEventDetailsConfigFactory(service: LazyClientConfigService): SitecoreEventDetailsConfig {
	return service.get(SitecoreEventDetailsConfig);
}

@LazyClientConfig({ key:'msSitecoreGameMessages' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: sitecoreGameMessagesConfigFactory,
})
export class SitecoreGameMessagesConfig extends LazyClientConfigBase {
	secondaryBroadcastInfo?: SecondaryBroadcastInfo;
}

export function sitecoreGameMessagesConfigFactory(service: LazyClientConfigService): SitecoreGameMessagesConfig {
	return service.get(SitecoreGameMessagesConfig);
}

@LazyClientConfig({ key:'msSitecoreMobileConfirmation' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: sitecoreMobileConfirmationConfigFactory,
})
export class SitecoreMobileConfirmationConfig extends LazyClientConfigBase {
	dialogCloseButtonText: string;
	dialogConfirmButtonText: string;
	dialogHeading: string;
	dialogUpdateButtonText: string;
	multiFactorAuthMessage: string;
	propertyName: string;
	updateMobileMessage: string;
	updatePhoneNumberURL: string;
}

export function sitecoreMobileConfirmationConfigFactory(service: LazyClientConfigService): SitecoreMobileConfirmationConfig {
	return service.get(SitecoreMobileConfirmationConfig);
}

@LazyClientConfig({ key:'msSitecoreMyBets' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: sitecoreMyBetsConfigFactory,
})
export class SitecoreMyBetsConfig extends LazyClientConfigBase {
	myBets: Record<string, string | undefined>;
	myBetsImages: MyBetsBetslipImage[];
	myBetsTax: Record<string, string | undefined>;
	myBets_NotLoggedIn?: ClientViewTemplate;
}

export function sitecoreMyBetsConfigFactory(service: LazyClientConfigService): SitecoreMyBetsConfig {
	return service.get(SitecoreMyBetsConfig);
}

@LazyClientConfig({ key:'msSitecoreOddsPreference' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: sitecoreOddsPreferenceConfigFactory,
})
export class SitecoreOddsPreferenceConfig extends LazyClientConfigBase {
	acceptAnyOddsLabel: string;
	acceptAnyOddsSubtext: string;
	acceptOnlyHigherOddsLabel: string;
	acceptOnlyHigherOddsSubtext: string;
	description: string;
	dontAcceptOddChangesLabel: string;
	helperText: string;
	oddChangePreferenceError: string;
	oddChangePreferenceSuccess: string;
	oddsPreferencePopupTitle: string;
	saveButton: string;
	tooltipText: string;
}

export function sitecoreOddsPreferenceConfigFactory(service: LazyClientConfigService): SitecoreOddsPreferenceConfig {
	return service.get(SitecoreOddsPreferenceConfig);
}

@LazyClientConfig({ key:'msSitecorePopularBets' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: sitecorePopularBetsConfigFactory,
})
export class SitecorePopularBetsConfig extends LazyClientConfigBase {
	logos: PopularBetsFallbackLogoModel[];
	messages: PopularBetsMessagesConfig;
}

export function sitecorePopularBetsConfigFactory(service: LazyClientConfigService): SitecorePopularBetsConfig {
	return service.get(SitecorePopularBetsConfig);
}

@LazyClientConfig({ key:'msSitecoreTokenCardDetails' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: sitecoreTokenCardDetailsConfigFactory,
})
export class SitecoreTokenCardDetailsConfig extends LazyClientConfigBase {
	betAndGetCardDetailsQualify?: TokenCardDetailsReplaceParameters;
	betAndGetV2CardDetailsQualify?: TokenCardDetailsReplaceParameters;
	freeBetCardDetailsQualify?: TokenCardDetailsReplaceParameters;
	freeBetV2CardDetailsQualify?: TokenCardDetailsReplaceParameters;
	messages?: TokenCardDetailsMessages;
	oddsBoostCardDetailsQualify?: TokenCardDetailsReplaceParameters;
	oddsBoostV2CardDetailsQualify?: TokenCardDetailsReplaceParameters;
	riskFreeCardDetailsQualify?: TokenCardDetailsReplaceParameters;
	riskFreeV2CardDetailsQualify?: TokenCardDetailsReplaceParameters;
}

export function sitecoreTokenCardDetailsConfigFactory(service: LazyClientConfigService): SitecoreTokenCardDetailsConfig {
	return service.get(SitecoreTokenCardDetailsConfig);
}

@LazyClientConfig({ key:'msSitemapSitecore' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: sitemapSitecoreFactory,
})
export class SitemapSitecore extends LazyClientConfigBase {
	AllLeagues: string;
	AllTournaments: string;
	Calendar: string;
	Close: string;
	ConferenceDrawerTooltip: string;
	CouponDrawerSubtitle: string;
	CouponDrawerTooltip: string;
	Coupons: string;
	Esports: string;
	Favourites: string;
	Featured: string;
	LeagueDrawerTooltip: string;
	Live: string;
	LiveCasino: string;
	LiveVideo: string;
	MultiBuilder: string;
	MultiSportsHub: string;
	Outrights: string;
	SeeAll: string;
	SelectConference: string;
	SelectLeague: string;
	SelectTournament: string;
	Specials: string;
	Standings: string;
	TournamentDrawerTooltip: string;
}

export function sitemapSitecoreFactory(service: LazyClientConfigService): SitemapSitecore {
	return service.get(SitemapSitecore);
}

@ClientConfig({ key:'msSkeleton' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: skeletonConfigFactory,
})
export class SkeletonConfig {
	isEnabled: boolean;
	maxtimeToSkeletonDuration: number;
	skeletonAniminationStartAt: number;
}

export function skeletonConfigFactory(service: ClientConfigService): SkeletonConfig {
	return service.get(SkeletonConfig);
}

@LazyClientConfig({ key:'msSportMarkets' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: sportMarketsConfigurationFactory,
})
export class SportMarketsConfiguration extends LazyClientConfigBase {
	markets: Record<number, Record<string, string | undefined> | undefined>;
	maxFixturesCount: number;
}

export function sportMarketsConfigurationFactory(service: LazyClientConfigService): SportMarketsConfiguration {
	return service.get(SportMarketsConfiguration);
}

@ClientConfig({ key:'msSportsApiVersion' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: sportsApiVersionConfigFactory,
})
export class SportsApiVersionConfig {
	sportsApiVersion: string;
	sportsApiVersionHeaderName: string;
}

export function sportsApiVersionConfigFactory(service: ClientConfigService): SportsApiVersionConfig {
	return service.get(SportsApiVersionConfig);
}

@ClientConfig({ key:'msSports' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: sportsConfigFactory,
})
export class SportsConfig {
	competitionLandingPage: number[];
	competitionOfferPriority: SportOfferOrder;
	topCompetitions: number[];
	virtuals: VirtualSportsConfiguration;
}

export function sportsConfigFactory(service: ClientConfigService): SportsConfig {
	return service.get(SportsConfig);
}

@ClientConfig({ key:'msSportsProductMenu' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: sportsProductMenuConfigFactory,
})
export class SportsProductMenuConfig {
	recentlyVisitedExpirationDays: number;
	version: string;
}

export function sportsProductMenuConfigFactory(service: ClientConfigService): SportsProductMenuConfig {
	return service.get(SportsProductMenuConfig);
}

@LazyClientConfig({ key:'msSportsProductMenuConfigV2' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: sportsProductMenuConfigV2Factory,
})
export class SportsProductMenuConfigV2 extends LazyClientConfigBase {
	allSportsSection?: AllSportsSection;
	popularSection?: PopularSection;
	recentlyVisitedSection?: RecentlyVisitedSection;
}

export function sportsProductMenuConfigV2Factory(service: LazyClientConfigService): SportsProductMenuConfigV2 {
	return service.get(SportsProductMenuConfigV2);
}

@LazyClientConfig({ key:'msSportsProductMenuSitecore' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: sportsProductMenuSitecoreFactory,
})
export class SportsProductMenuSitecore extends LazyClientConfigBase {
	AllLeaguesClose: string;
	AllLeaguesHeader: string;
}

export function sportsProductMenuSitecoreFactory(service: LazyClientConfigService): SportsProductMenuSitecore {
	return service.get(SportsProductMenuSitecore);
}

@ClientConfig({ key:'msSportsUser' , product: ClientConfigProductName.SPORTS, reload: true })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: sportsUserConfigFactory,
})
export class SportsUserConfig {
	associatedAccount?: string;
	cdnaProfileDetails: CdnaUserProfile;
	clientIP: string;
	columnSize?: number;
	isEarlyPayoutAllowed: boolean;
	isEligibleForNewCustomerOffer: boolean;
	isQuickDepositEnabled: boolean;
	jurisdiction: string;
}

export function sportsUserConfigFactory(service: ClientConfigService): SportsUserConfig {
	return service.get(SportsUserConfig);
}

@LazyClientConfig({ key:'msSportsUserSettings' , product: ClientConfigProductName.SPORTS, reload: true })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: sportsUserSettingsFactory,
})
export class SportsUserSettings extends LazyClientConfigBase {
	bettingSettings: UserSettingsData;
	configSettings: ConfigSettings;
}

export function sportsUserSettingsFactory(service: LazyClientConfigService): SportsUserSettings {
	return service.get(SportsUserSettings);
}

@ClientConfig({ key:'msStake' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: stakeConfigFactory,
})
export class StakeConfig {
	addToStakeValues: Record<string, number[] | undefined>;
	checkUserStakeLimit: boolean;
	isMaxStakePerBetslipStrategy: boolean;
	maxLeadingDigits: Record<string, number | undefined>;
	maxStakeByCurrency?: Record<string, number | undefined>;
	minStakeThresholdValue: number;
	showStakeLimitInfo: boolean;
	stakeValuesByCurrency: Record<string, number[] | undefined>;
}

export function stakeConfigFactory(service: ClientConfigService): StakeConfig {
	return service.get(StakeConfig);
}

@ClientConfig({ key:'msStatistics' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: statisticsConfigFactory,
})
export class StatisticsConfig {
	directMatchesBarColors: DirectMatchesBarColors;
	expandedLeagueTablesCount: number;
	isPerformStatsEnabled: boolean;
	pitcherEnabledSports: number[];
	promotionHighlightColors: Record<number, Record<number, string | undefined> | undefined>;
	promotionHighlightColorsWithPositions: PromotionHighlightColorsWithPositions;
	statisticsUrlTemplate: string;
	supportedSports: number[];
	teamRankEnabledSports: number[];
	teamRecordsFormat: Record<number, CompetitionRecordsFormat | undefined>;
}

export function statisticsConfigFactory(service: ClientConfigService): StatisticsConfig {
	return service.get(StatisticsConfig);
}

@ClientConfig({ key:'msStory' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: storyConfigFactory,
})
export class StoryConfig {
	minSwipeDistance: number;
}

export function storyConfigFactory(service: ClientConfigService): StoryConfig {
	return service.get(StoryConfig);
}

@ClientConfig({ key:'msStylingGrid' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: stylingGridConfigurationFactory,
})
export class StylingGridConfiguration {
	participantImageSportBlacklist: number[];
	showParticipantBoldName: boolean;
}

export function stylingGridConfigurationFactory(service: ClientConfigService): StylingGridConfiguration {
	return service.get(StylingGridConfiguration);
}

@ClientConfig({ key:'msTaxation' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: taxationConfigFactory,
})
export class TaxationConfig {
	isTaxationEnabled: boolean;
	taxableSports: number[];
}

export function taxationConfigFactory(service: ClientConfigService): TaxationConfig {
	return service.get(TaxationConfig);
}

@ClientConfig({ key:'msTeamPages' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: teamPagesConfigFactory,
})
export class TeamPagesConfig {
	blacklistedCompetitions: string[];
	imageProfileEnabledSportIds: number[];
	isEnabled: boolean;
	isEnabledOnHomeLobby: boolean;
	isNewBadgeEnabled: boolean;
	maxCompetitions: number;
	minTeamsOnHomeLobby: number;
	sportsToDisplayLogos: number[];
	whitelistedSports: number[];
}

export function teamPagesConfigFactory(service: ClientConfigService): TeamPagesConfig {
	return service.get(TeamPagesConfig);
}

@LazyClientConfig({ key:'msTeamPagesModule' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: teamPagesModuleConfigFactory,
})
export class TeamPagesModuleConfig extends LazyClientConfigBase {
	backgroundImages: ScoreboardBackgroundModel;
	teamPageItems: TeamPagesViewModel;
}

export function teamPagesModuleConfigFactory(service: LazyClientConfigService): TeamPagesModuleConfig {
	return service.get(TeamPagesModuleConfig);
}

@LazyClientConfig({ key:'msTeaserBet' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: teaserBetConfigFactory,
})
export class TeaserBetConfig extends LazyClientConfigBase {
	allowedTemplateIds: TeaserBetTemplateIds[];
	isEnabled: boolean;
	isTeaserPickPriceTrackingEnabled: boolean;
	pointsSliderConfig: TeaserBetPointsSlider[];
	priceTableCache: TeaserPriceTableCacheDuration;
}

export function teaserBetConfigFactory(service: LazyClientConfigService): TeaserBetConfig {
	return service.get(TeaserBetConfig);
}

@ClientConfig({ key:'msTimeFilter' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: timeFilterConfigFactory,
})
export class TimeFilterConfig {
	isTimeFilterEnabled: boolean;
	timeFilterOptions: string[];
	timeFilterOptionsForCoupons: string[];
}

export function timeFilterConfigFactory(service: ClientConfigService): TimeFilterConfig {
	return service.get(TimeFilterConfig);
}

@ClientConfig({ key:'msTopEvents' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: topEventsConfigFactory,
})
export class TopEventsConfig {
	maxEventsPerPod: number;
	maxOptionsPerOutrightPod: number;
	useAggregateMatchList: boolean;
}

export function topEventsConfigFactory(service: ClientConfigService): TopEventsConfig {
	return service.get(TopEventsConfig);
}

@LazyClientConfig({ key:'msTopNavigation' , product: ClientConfigProductName.SPORTS, reload: true })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: topNavigationConfigFactory,
})
export class TopNavigationConfig extends LazyClientConfigBase {
	afterSports: NavigationBarItem[];
	beforeSports: NavigationBarItem[];
	fixedItems: NavigationBarItem[];
	isDesktopNavigationCompact: boolean;
	maxSports: number;
	sportsConfig: NavigationSportsConfig;
	topNavigationItems: NavigationBarItem[];
}

export function topNavigationConfigFactory(service: LazyClientConfigService): TopNavigationConfig {
	return service.get(TopNavigationConfig);
}

@ClientConfig({ key:'msTournamentsData' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: tournamentsDataConfigFactory,
})
export class TournamentsDataConfig {
	tournaments: Tournament[];
}

export function tournamentsDataConfigFactory(service: ClientConfigService): TournamentsDataConfig {
	return service.get(TournamentsDataConfig);
}

@LazyClientConfig({ key:'msTrapImages' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [LazyClientConfigService],
	useFactory: trapImagesFactory,
})
export class TrapImages extends LazyClientConfigBase {
	dogTrap: TrapImage[];
	regionDogTraps: RegionTrapImage[];
}

export function trapImagesFactory(service: LazyClientConfigService): TrapImages {
	return service.get(TrapImages);
}

@ClientConfig({ key:'msUKGC' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: uKGCConfigFactory,
})
export class UKGCConfig {
	isPotentialReturnsEnabledForSingle: boolean;
}

export function uKGCConfigFactory(service: ClientConfigService): UKGCConfig {
	return service.get(UKGCConfig);
}

@ClientConfig({ key:'msWidget' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: widgetConfigFactory,
})
export class WidgetConfig {
	defaultRightColumn: Widget<unknown>[];
	orderedRenderingTimeout: number;
	pageRefreshInterval: PageRefreshConfig[];
}

export function widgetConfigFactory(service: ClientConfigService): WidgetConfig {
	return service.get(WidgetConfig);
}

@ClientConfig({ key:'msWorldCupHub' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: worldCupHubConfigFactory,
})
export class WorldCupHubConfig {
	isNewBadgeEnabled: boolean;
	wcEventHubURLs: CultureUrl[];
}

export function worldCupHubConfigFactory(service: ClientConfigService): WorldCupHubConfig {
	return service.get(WorldCupHubConfig);
}

@ClientConfig({ key:'msYahooOpenId' , product: ClientConfigProductName.SPORTS })
@Injectable({
	providedIn: 'root',
	deps: [ClientConfigService],
	useFactory: yahooOpenIdConfigFactory,
})
export class YahooOpenIdConfig {
	enableOnBetPlacement: boolean;
	nativeAppCookie: string;
}

export function yahooOpenIdConfigFactory(service: ClientConfigService): YahooOpenIdConfig {
	return service.get(YahooOpenIdConfig);
}

